/* eslint-disable no-multi-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-case-declarations */
import { Box, Switch } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import {
  getNotificationPermissionsByUserId,
  NotificationPermissions,
  updateNotificationsPermissions,
} from '../../../../services/requests/permissao-notificacoes';
import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';
import { Title, SectionPermissions, RowPermissions, TextName } from './styles';

export const NotificationsPermissions = () => {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [notificationPermissionsUser, setNotificationPermissionsUser] =
    useState<NotificationPermissions>();

  const [webPermissions, setWebPermissions] = useState([
    {
      title: 'Nova reunião',
      status: true,
      key: 'new_meeting_web',
    },
    {
      title: 'Alteração de reunião',
      status: true,
      key: 'updated_meeting_web',
    },
    {
      title: 'Cancelamento de reunião',
      status: true,
      key: 'cancelled_meeting_web',
    },
    {
      title: 'Inclusão em board',
      status: true,
      key: 'board_included_web',
    },
    {
      title: 'Solicitação de assinatura',
      status: true,
      key: 'subscription_request_web',
    },
    {
      title: 'Anotação compartilhada',
      status: true,
      key: 'shared_note_web',
    },
  ]);

  const [mobilePermissions, setMobilePermissions] = useState([
    {
      title: 'Nova reunião',
      status: true,
      key: 'new_meeting_app',
    },
    {
      title: 'Alteração de reunião',
      status: true,
      key: 'updated_meeting_app',
    },
    {
      title: 'Cancelamento de reunião',
      status: true,
      key: 'cancelled_meeting_app',
    },
    {
      title: 'Inclusão em board',
      status: true,
      key: 'board_included_app',
    },
    {
      title: 'Solicitação de assinatura',
      status: true,
      key: 'subscription_request_app',
    },
    {
      title: 'Anotação compartilhada',
      status: true,
      key: 'shared_note_app',
    },
  ]);

  const getPermissionsByUserId = useCallback(async () => {
    try {
      const response = await getNotificationPermissionsByUserId(
        user?.id as string,
      );

      if (response?.status === 200) {
        setNotificationPermissionsUser(response?.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, [user?.id]);

  useEffect(() => {
    if (user) {
      getPermissionsByUserId();
    }
  }, [user]);

  useEffect(() => {
    if (notificationPermissionsUser) {
      setWebPermissions([
        {
          title: 'Nova reunião',
          status: notificationPermissionsUser?.new_meeting_web as boolean,
          key: 'new_meeting_web',
        },
        {
          title: 'Alteração de reunião',
          status: notificationPermissionsUser?.updated_meeting_web as boolean,
          key: 'updated_meeting_web',
        },
        {
          title: 'Cancelamento de reunião',
          status: notificationPermissionsUser?.cancelled_meeting_web as boolean,
          key: 'cancelled_meeting_web',
        },
        {
          title: 'Inclusão em board',
          status: notificationPermissionsUser?.board_included_web as boolean,
          key: 'board_included_web',
        },
        {
          title: 'Solicitação de assinatura',
          status:
            notificationPermissionsUser?.subscription_request_web as boolean,
          key: 'subscription_request_web',
        },
        {
          title: 'Anotação compartilhada',
          status: notificationPermissionsUser?.shared_note_web as boolean,
          key: 'shared_note_web',
        },
      ]);
      setMobilePermissions([
        {
          title: 'Nova reunião',
          status: notificationPermissionsUser?.new_meeting_app as boolean,
          key: 'new_meeting_app',
        },
        {
          title: 'Alteração de reunião',
          status: notificationPermissionsUser?.updated_meeting_app as boolean,
          key: 'updated_meeting_app',
        },
        {
          title: 'Cancelamento de reunião',
          status: notificationPermissionsUser?.cancelled_meeting_app as boolean,
          key: 'cancelled_meeting_app',
        },
        {
          title: 'Inclusão em board',
          status: notificationPermissionsUser?.board_included_app as boolean,
          key: 'board_included_app',
        },
        {
          title: 'Solicitação de assinatura',
          status:
            notificationPermissionsUser?.subscription_request_app as boolean,
          key: 'subscription_request_app',
        },
        {
          title: 'Anotação compartilhada',
          status: notificationPermissionsUser?.shared_note_app as boolean,
          key: 'shared_note_app',
        },
      ]);
    }
  }, [notificationPermissionsUser]);

  const handleChangeWebPermission = async (name: string, index: number) => {
    let newPermissions = [];
    switch (name) {
      case 'Nova reunião':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      case 'Alteração de reunião':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      case 'Cancelamento de reunião':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      case 'Inclusão em board':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      case 'Solicitação de assinatura':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      case 'Anotação compartilhada':
        newPermissions = [...webPermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setWebPermissions(newPermissions);
        break;
      default:
        return null;
    }

    const notificationPermissionsWebData = webPermissions.reduce(
      (acc, web) => ({
        ...acc,
        [`${web.key}`]: web.status as any,
      }),
      {},
    );

    if (notificationPermissionsWebData) {
      await updateNotificationsPermissions(
        notificationPermissionsUser?.id as string,
        user?.id as string,
        selectedCompany?.id as string,
        notificationPermissionsWebData as NotificationPermissions,
      );
    }
  };

  const handleChangeMobilePermission = async (name: string, index: number) => {
    let newPermissions = [];
    switch (name) {
      case 'Nova reunião':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      case 'Alteração de reunião':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      case 'Cancelamento de reunião':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      case 'Inclusão em board':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      case 'Solicitação de assinatura':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      case 'Anotação compartilhada':
        newPermissions = [...mobilePermissions];
        newPermissions[index].status = !newPermissions[index].status;
        setMobilePermissions(newPermissions);
        break;
      default:
        return null;
    }

    const notificationPermissionsMobileData = mobilePermissions.reduce(
      (acc, web) => ({
        ...acc,
        [`${web.key}`]: web.status as any,
      }),
      {},
    );

    if (notificationPermissionsMobileData) {
      await updateNotificationsPermissions(
        notificationPermissionsUser?.id as string,
        user?.id as string,
        selectedCompany?.id as string,
        notificationPermissionsMobileData as NotificationPermissions,
      );
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="20px">
      <Box>
        <Title>Notificações por e-mail</Title>
        <SectionPermissions>
          {webPermissions?.map((p, index) => (
            <RowPermissions>
              <TextName>{p?.title}</TextName>
              <Switch
                checked={p?.status}
                onClick={() => handleChangeWebPermission(p?.title, index)}
              />
            </RowPermissions>
          ))}
        </SectionPermissions>
      </Box>
      <Box>
        <Title>Notificações aplicativo</Title>
        <SectionPermissions>
          {mobilePermissions?.map((p, index) => (
            <RowPermissions>
              <TextName>{p?.title}</TextName>
              <Switch
                checked={p?.status}
                onClick={() => handleChangeMobilePermission(p?.title, index)}
              />
            </RowPermissions>
          ))}
        </SectionPermissions>
      </Box>
    </Box>
  );
};
